module.exports = __webpack_public_path__ + "img/bf5a2d2.jpg";